import { Col, Form, Input, Row } from 'antd'
import DeliveryCollectionDisplay from '../../../components/Purchasing/Order/DeliveryCollectionDisplay'
import * as convertUnits from 'convert-units'
import CustomSpin from '../../../elements/CustomSpin'
import DeliveryDetails from '../../../elements/DeliveryDetails'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import withSort from '../../../elements/HOC/withSort'
import withSpinning from '../../../elements/HOC/withSpinning'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withData from '../../../elements/Select/withData'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import { get, isEmpty, merge, round, upperCase } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, threeFormItemLayout } from '../../../modules/FormItems'
import React, { useEffect, useState } from 'react'
import { compose } from 'recompose'
import * as stringSimilarity from 'string-similarity'
import ShippingDetails from '../../../elements/ShippingDetails'

function getAddrVal(data, accessor, strict = true, threshold = 0.65) {
  if (data) {
    const values = data.map((d) => get(d, accessor)) || []
    let isMatched
    if (strict) {
      isMatched = values.every((t) => t === values[0])
    } else {
      isMatched = values.every((t) => {
        return stringSimilarity.compareTwoStrings(upperCase(t), upperCase(values[0])) > threshold
      })
    }
    const value = isMatched ? values[0] : ''
    return value
  }
}

function getTotalWeight(packages = []) {
  const totalWeight = packages.reduce((acc, p) => {
    try {
      const v = p.shipping.weights
      const unit = parseInt(p.unit)

      return convertUnits(v.net).from(v.scale.code).to('kg') * unit + acc
    } catch (e) {
      console.log('Error', e)
      return 0
    }
  }, 0)

  return round(totalWeight, 2)
}

function CargoForm(props) {
  const { cargo, fetching, selection, isConfirmed, currentRoute, hideDisplay = false } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form

  console.log({ selection })

  const CargoCategory = compose(
    withSelectFetch({ dropdown: 'delivery', name: getFieldValue('type') || '' }),
    withSpinning,
    withSort
  )(CustomSelect)

  let sharedAddress = {
    type: getAddrVal(selection, 'to.type'),
    country: getAddrVal(selection, 'to.country'),
    terms: getAddrVal(selection, 'to.terms'),
    location: getAddrVal(selection, 'to.location'),
    method: getAddrVal(selection, 'to.method'),
    address: {
      label: getAddrVal(selection, 'to.address.label', false),
    },
  }

  const isAllSameDO = selection.every((s) => get(s, 'deliveryOrder._id') === get(selection, '[0].deliveryOrder._id'))

  const weights = getTotalWeight(selection)
  const shipping = {
    shipping: {
      country: {
        origin: getAddrVal(selection, 'shipping.country.origin'),
        destination: getAddrVal(selection, 'shipping.country.destination'),
      },
      stackable: getAddrVal(selection, 'shipping.stackable'),
      weights: { net: weights },
    },
  }

  const weightNet = getFieldValue('shipping.weights.net') || ''
  const weightGross = getFieldValue('shipping.weights.gross') || get(cargo, 'shipping.weights.gross', '')

  useEffect(() => {
    if (weightGross !== undefined && weightNet === undefined) {
      setFieldsValue({ 'shipping.weights.gross': weightNet })
      // console.log(weightNet, typeof weightGross, 'in')
    } else {
      // console.log(weightNet, 'out')
    }
  }, [weightNet])

  return (
    <CustomSpin spinning={fetching}>
      <Form>
        <FormSectionTitle title={'Cargo Details'} />
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label={'Description'}>
              {getFieldDecorator('title', {
                initialValue: get(cargo, 'title') || (isAllSameDO ? get(selection, '[0].deliveryOrder.title') : ''),
                rules: [
                  {
                    required: true,
                    message: 'Please input Description of Goods!',
                  },
                ],
              })(<Input placeholder={'Title'} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Package Final Destination'}>
              {getFieldDecorator('isPackageFinalDestination', {
                initialValue: get(cargo, 'isPackageFinalDestination'),
                rules: [
                  {
                    required: true,
                    message: 'Please Select a Package Status Type!',
                  },
                ],
              })(<PackageFinalDestinationSelect placeholder={'Package Final Destination'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'No Packages'}>
              {getFieldDecorator('noPackages', {
                initialValue: get(cargo, 'noPackages') || selection.length,
              })(<Input placeholder={'No of Packages'} disabled />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Cargo Type '}>
              {getFieldDecorator('type', {
                initialValue: get(cargo, 'type'),
                rules: [{ required: true, message: 'Please Select a Cargo Type!' }],
              })(<CargoType placeholder={'Cargo Type'} />)}
            </Form.Item>
          </Col>
          {getFieldValue('type') && ['LCL', 'container'].includes(getFieldValue('type')) && (
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'Category'}>
                {getFieldDecorator('category', {
                  initialValue: get(cargo, 'category'),
                  rules: [{ required: true, message: 'Please Select a Category!' }],
                })(
                  <CargoCategory
                    // setSelected={setCargoCategory}
                    placeholder={'Category'}
                  />
                )}
              </Form.Item>
            </Col>
          )}
        </Row>
        {['container'].includes(getFieldValue('type')) && (
          <Row>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'Container No: '}>
                {getFieldDecorator('containerNo', {
                  initialValue: get(cargo, 'containerNo'),
                  rules: [{ required: false, message: 'Please Input Container No' }],
                })(<Input placeholder={'Cargo Type'} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'Container Seal: '}>
                {getFieldDecorator('containerSeal', {
                  initialValue: get(cargo, 'containerSeal'),
                  rules: [
                    {
                      required: false,
                      message: 'Please Input Container Seal No',
                    },
                  ],
                })(<Input placeholder={'Cargo Type'} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'TARE Weight: '}>
                {getFieldDecorator('tare', {
                  initialValue: get(cargo, 'tare'),
                  rules: [{ required: false, message: 'Please Input TARE Weight' }],
                })(<Input placeholder={'TARE Weight'} />)}
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row>
          <ShippingDetails
            line={merge(shipping, { shipping: cargo.shipping })}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'cargo',
            }}
          />
        </Row>

        <Row>
          <FormSectionTitle title={'Final Destination of Cargo'} />
          <DeliveryDetails
            doc={!isEmpty(cargo) ? cargo : { final: sharedAddress }}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'Cargo',
              prefix: 'final',
              hideTitle: true,
              viewOnly: isConfirmed,
              hideDangerous: true,
            }}
          />
        </Row>

        {!hideDisplay && (
          <Row>
            <DeliveryCollectionDisplay
              start={'Start Location'}
              end={'End Location'}
              doc={{
                collection: get(currentRoute, 'start.location'),
                delivery: get(currentRoute, 'end.location'),
              }}
            />
          </Row>
        )}
      </Form>
    </CustomSpin>
  )
}

CargoForm.propTypes = {}
CargoForm.defaultProps = {
  selection: [],
}

export default Form.create()(CargoForm)

const CargoType = compose(
  withSelectFetch({ dropdown: 'delivery', name: 'cargoType' }),
  withSpinning,
  withSort
)(CustomSelect)

const PackageFinalDestinationSelect = compose(
  withData({
    data: [
      { key: 'yes', value: 'Yes (Mark Packages As delivered)' },
      { key: 'no', value: 'No (Release Packages)' },
      { key: 'unsure', value: 'Unsure (Decide Later)' },
    ],
  })
  // withSort,
)(CustomSelect)
